<template>
  <div id="services-web-app">
    <PageHeader fixed />
    <main>
      <section
        id="main"
        class="teal white-text hero-section pt-12 pb-12 lg:pt-24 lg:pb-18"
        :style="{ backgroundImage: `url('/images/services/web-app/geometric-1.webp') !important` }"
      >
        <div class="container-lg items-center grid grid-cols-1 lg:grid-cols-2 gap-4 pt-4 pb-8">
          <div class="hide-on-med-and-down">
            <PictureImg
              src="/images/services/web-app/web-app-development"
              alt="Web App Development"
              version="1"
              :extensions="['webp', 'png']"
              :lazy="false"
              img-class="hero-image"
            />
          </div>
          <div>
            <div class="hero-text">
              <h1 class="font-bold text-5xl lg:text-8xl uppercase">Web/App Development Service</h1>
              <div class="hide-on-large-only text-center">
                <PictureImg
                  src="/images/services/web-app/web-app-development"
                  alt="Web App Development"
                  version="1"
                  :extensions="['webp', 'png']"
                  :lazy="false"
                  img-class="hero-image px-9"
                />
              </div>
              <p class="font-medium text-xl lg:text-2xl text-balance px-4 lg:px-0">
                At Rasylva.id, we create high-quality, customizable, and maintainable digital solutions to support your
                needs.
              </p>
              <a
                href="https://wa.me/6285187877001?text=Halo%20Admin%20Rasylva.id!%0ASaya%20datang%20dari%20website%20Rasylva.id.%0A%0ANama%3A%0AInstansi%3A%0A%0ASaya%20mau%20bertanya%20tentang%20..."
                class="btn waves-effect green btn-large font-medium px-9 uppercase"
                target="_blank"
                rel="noreferrer"
                >Free Consultation!</a
              >
            </div>
          </div>
        </div>
      </section>

      <section id="expertise" class="expertise-section">
        <div class="container grid grid-cols-1 lg:grid-cols-2 gap-4">
          <div class="hide-on-large-only" style="text-align: center; margin-top: 24px">
            <PictureImg
              src="/images/services/web-app/technical-natural-science"
              alt="Technical Natural Science"
              version="1"
              :extensions="['webp', 'png']"
              :lazy="false"
              img-class="expertise-illustration"
            />
          </div>
          <div class="expertise-text">
            <h2 class="expertise-heading">Combining technical expertise with a foundation in natural science</h2>
            <p class="expertise-description">
              From research-driven platforms to environmental applications, we understand the precision these fields
              require. Our expertise extends to businesses across all industries that value innovation and
              sustainability.
            </p>
          </div>
          <div class="expertise-image hide-on-med-and-down">
            <PictureImg
              src="/images/services/web-app/technical-natural-science"
              alt="Technical Natural Science"
              version="1"
              :extensions="['webp', 'png']"
              :lazy="false"
              img-class="expertise-illustration"
            />
          </div>
        </div>
      </section>

      <section
        id="services"
        class="relative container-lg mx-0 w-full lg:mx-auto my-24 lg:my-48 green px-9 lg:px-18 pt-18 pb-24 rounded-3xl lg:pt-24 lg:pb-36"
        :style="{
          backgroundImage: `url('/images/services/web-app/geometric-0.webp') !important`,
          backgroundSize: 'cover !important',
          backgroundPosition: 'left center !important',
          backgroundRepeat: 'no-repeat !important',
        }"
      >
        <h2 class="center-align text-3xl lg:text-4xl font-bold white-text mb-12 uppercase">Our Services</h2>
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 center-align">
          <div class="white rounded-xl py-11 px-4">
            <PictureImg
              src="/images/services/web-app/service-web"
              alt="Quality Illustration"
              :extensions="['webp', 'png']"
              img-class="lg:mb-2"
              :img-style="{ display: 'block', height: '14vh', maxHeight: '150px', margin: 'auto' }"
            />
            <h4 class="text-2xl lg:text-2xl m-0 mb-2 lg:mb-2 mt-4 txt--bold text-balance">Website Development</h4>
            <span class="text-lg lg:text-xl text-balance"
              >Modern, responsive, and scalable websites tailored to your goals.
            </span>
          </div>
          <div class="white rounded-xl py-11 px-4">
            <PictureImg
              src="/images/services/web-app/service-app"
              alt="Affordable Illustration"
              :extensions="['webp', 'png']"
              img-class="lg:mb-2"
              :img-style="{ display: 'block', height: '14vh', maxHeight: '150px', margin: 'auto' }"
            />
            <h4 class="text-2xl lg:text-2xl m-0 mb-2 lg:mb-2 mt-4 txt--bold text-balance">Mobile App Development</h4>
            <span class="text-lg lg:text-xl text-balance">Engaging iOS & Android apps with smooth performance.</span>
          </div>
          <div class="white rounded-xl py-11 px-4">
            <PictureImg
              src="/images/services/web-app/service-software"
              alt="Friendly Illustration"
              :extensions="['webp', 'png']"
              img-class="lg:mb-2"
              :img-style="{ display: 'block', height: '14vh', maxHeight: '150px', margin: 'auto' }"
            />
            <h4 class="text-2xl lg:text-2xl m-0 mb-2 lg:mb-2 mt-4 txt--bold text-balance">
              Custom Software Development
            </h4>
            <span class="text-lg lg:text-xl text-balance">Tailor-made solutions built around your specific needs.</span>
          </div>
        </div>
      </section>

      <section id="why-choose-us" class="relative container-lg my-24 lg:my-48">
        <h2 class="center-align text-3xl lg:text-4xl font-bold teal-text text-darken-3 text-darken-3 mb-12 uppercase">
          Why Choose Us?
        </h2>
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-x-4 gap-y-8 center-align">
          <div>
            <PictureImg
              src="/images/services/web-app/why-quality"
              alt="Quality Illustration"
              :extensions="['webp', 'png']"
              img-class="mb-2 lg:mb-4"
              :img-style="{ display: 'block', height: '14vh', maxHeight: '150px', margin: 'auto' }"
            />
            <h4 class="text-2xl lg:text-2xl m-0 lg:mb-2 txt--bold">High Quality</h4>
            <p class="text-lg lg:text-xl text-balance">
              Built with best practices and tested for performance, security, and reliability.
            </p>
          </div>
          <div>
            <PictureImg
              src="/images/services/web-app/why-customizable"
              alt="Customizable Illustration"
              :extensions="['webp', 'png']"
              img-class="mb-2 lg:mb-4"
              :img-style="{
                display: 'block',
                height: '14vh',
                maxHeight: '140px',
                margin: 'auto',
                marginTop: '10px',
                paddingLeft: '24px',
              }"
            />
            <h4 class="text-2xl lg:text-2xl m-0 lg:mb-2 txt--bold">Customizable</h4>
            <p class="text-lg lg:text-xl text-balance">Flexible solutions that adapt to your unique needs.</p>
          </div>
          <div>
            <PictureImg
              src="/images/services/web-app/why-maintainable"
              alt="Maintainable Illustration"
              :extensions="['webp', 'png']"
              img-class="mb-2 lg:mb-4"
              :img-style="{ display: 'block', height: '14vh', maxHeight: '150px', margin: 'auto' }"
            />
            <h4 class="text-2xl lg:text-2xl m-0 lg:mb-2 txt--bold">Maintainable</h4>
            <p class="text-lg lg:text-xl text-balance">
              Clean, well-documented, and maintainable code built for long-term sustainability.
            </p>
          </div>
          <div>
            <PictureImg
              src="/images/services/web-app/why-seo"
              alt="SEO Optimized Illustration"
              :extensions="['webp', 'png']"
              img-class="mb-2 lg:mb-4"
              :img-style="{ display: 'block', height: '14vh', maxHeight: '150px', margin: 'auto', paddingTop: '30px' }"
            />
            <h4 class="text-2xl lg:text-2xl m-0 lg:mb-2 txt--bold">SEO Optimized</h4>
            <p class="text-lg lg:text-xl text-balance">
              Developed with SEO optimization to improve visibility and ranking across search engines.
            </p>
          </div>
          <div>
            <PictureImg
              src="/images/services/web-app/why-design"
              alt="Modern Design Illustration"
              :extensions="['webp', 'png']"
              img-class="mb-2 lg:mb-4"
              :img-style="{ display: 'block', height: '14vh', maxHeight: '150px', margin: 'auto', paddingLeft: '36px' }"
            />
            <h4 class="text-2xl lg:text-2xl m-0 lg:mb-2 txt--bold">Modern Design</h4>
            <p class="text-lg lg:text-xl text-balance">
              Every product is designed to be easy to use, fully responsive, and visually professional.
            </p>
          </div>
          <div>
            <PictureImg
              src="/images/services/web-app/why-professional"
              alt="Professional Team Illustration"
              :extensions="['webp', 'png']"
              img-class="mb-2 lg:mb-4"
              :img-style="{
                display: 'block',
                height: '14vh',
                maxHeight: '140px',
                margin: 'auto',
                paddingTop: '20px',
                paddingRight: '32px',
              }"
            />
            <h4 class="text-2xl lg:text-2xl m-0 lg:mb-2 txt--bold">Professional Team</h4>
            <p class="text-lg lg:text-xl text-balance">
              Skilled developers and designers experienced across diverse industry projects.
            </p>
          </div>
        </div>
      </section>

      <section id="project-workflow" class="relative container-lg my-24 lg:my-48">
        <h2 class="center-align text-3xl lg:text-4xl font-bold teal-text text-darken-3 text-darken-3 mb-12 uppercase">
          Project Workflow
        </h2>
        <div class="flex flex-col lg:flex-row gap-y-6 lg:gap-x-4 lg:gap-y-12 center-align mb-4 justify-center">
          <div class="w-full lg:w-1/5">
            <PictureImg
              src="/images/services/web-app/process-planning"
              alt="Planning"
              :extensions="['webp', 'png']"
              img-class="lg:mb-2"
              :img-style="{ display: 'block', height: '14vh', maxHeight: '150px', margin: 'auto' }"
            />
            <h4
              class="text-2xl lg:text-2xl m-0 lg:mb-2 txt--bold teal white-text uppercase mt-4 inline-block px-4 lg:px-2 py-1"
            >
              1. Planning
            </h4>
            <p class="text-lg lg:text-xl text-balance">
              Defining project goals, user needs, and technical requirements to lay a solid foundation
            </p>
          </div>
          <div class="mb-2 lg:mb-0" style="min-width: 72px">
            <PictureImg
              src="/images/services/web-app/arrow-right"
              alt="Design"
              :extensions="['webp', 'png']"
              img-class="lg:mb-2 object-contain hide-on-med-and-down"
              :img-style="{
                display: 'block',
                maxWidth: '98px',
                width: '100%',
                height: '50px',
                margin: 'auto',
                top: '50%',
                position: 'relative',
              }"
            />
            <svg
              class="object-contain hide-on-large-only mx-auto"
              width="48"
              height="60"
              viewBox="0 0 48 60"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              style="display: block"
            >
              <rect x="22" y="16" width="4" height="30" rx="2" fill="black" />
              <path
                d="M12 32 L24 48 L36 32"
                stroke="black"
                stroke-width="5"
                stroke-linecap="round"
                stroke-linejoin="round"
                fill="none"
              />
            </svg>
          </div>
          <div class="w-full lg:w-1/5">
            <PictureImg
              src="/images/services/web-app/process-design"
              alt="Design"
              :extensions="['webp', 'png']"
              img-class="lg:mb-2"
              :img-style="{ display: 'block', height: '14vh', maxHeight: '150px', margin: 'auto' }"
            />
            <h4
              class="text-2xl lg:text-2xl m-0 lg:mb-2 txt--bold teal white-text uppercase mt-4 inline-block px-4 lg:px-2 py-1"
            >
              2. Design
            </h4>
            <p class="text-lg lg:text-xl text-balance">
              Creating intuitive user experiences with clean, modern interfaces
            </p>
          </div>
          <div class="mb-2 lg:mb-0" style="min-width: 72px">
            <PictureImg
              src="/images/services/web-app/arrow-right"
              alt="Design"
              :extensions="['webp', 'png']"
              img-class="lg:mb-2 object-contain hide-on-med-and-down"
              :img-style="{
                display: 'block',
                maxWidth: '98px',
                width: '100%',
                height: '50px',
                margin: 'auto',
                top: '50%',
                position: 'relative',
              }"
            />
            <svg
              class="object-contain hide-on-large-only mx-auto"
              width="48"
              height="60"
              viewBox="0 0 48 60"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              style="display: block"
            >
              <rect x="22" y="16" width="4" height="30" rx="2" fill="black" />
              <path
                d="M12 32 L24 48 L36 32"
                stroke="black"
                stroke-width="5"
                stroke-linecap="round"
                stroke-linejoin="round"
                fill="none"
              />
            </svg>
          </div>
          <div class="w-full lg:w-1/5">
            <PictureImg
              src="/images/services/web-app/process-development"
              alt="Friendly Illustration"
              :extensions="['webp', 'png']"
              img-class="lg:mb-2"
              :img-style="{ display: 'block', height: '14vh', maxHeight: '150px', margin: 'auto' }"
            />
            <h4
              class="text-2xl lg:text-2xl m-0 lg:mb-2 txt--bold teal white-text uppercase mt-4 inline-block px-4 lg:px-2 py-1"
            >
              3. Development
            </h4>
            <p class="text-lg lg:text-xl text-balance">Building robust, efficient, and scalable solutions.</p>
          </div>
        </div>
        <div class="flex flex-col lg:flex-row gap-y-6 lg:gap-x-4 lg:gap-y-12 center-align mb-12 justify-center">
          <div class="mb-2 lg:mb-0 hide-on-large-only" style="min-width: 72px">
            <svg
              class="object-contain hide-on-large-only mx-auto"
              width="48"
              height="60"
              viewBox="0 0 48 60"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              style="display: block"
            >
              <rect x="22" y="16" width="4" height="30" rx="2" fill="black" />
              <path
                d="M12 32 L24 48 L36 32"
                stroke="black"
                stroke-width="5"
                stroke-linecap="round"
                stroke-linejoin="round"
                fill="none"
              />
            </svg>
          </div>
          <div class="w-full lg:w-1/5">
            <PictureImg
              src="/images/services/web-app/process-review"
              alt="Review"
              :extensions="['webp', 'png']"
              img-class="lg:mb-2"
              :img-style="{ display: 'block', height: '14vh', maxHeight: '150px', margin: 'auto' }"
            />
            <h4
              class="text-2xl lg:text-2xl m-0 lg:mb-2 txt--bold teal white-text uppercase mt-4 inline-block px-4 lg:px-2 py-1"
            >
              4. Review
            </h4>
            <p class="text-lg lg:text-xl text-balance">
              Testing thoroughly and gathering feedback to refine the product
            </p>
          </div>
          <div class="mb-2 lg:mb-0" style="min-width: 72px">
            <PictureImg
              src="/images/services/web-app/arrow-right"
              alt="Design"
              :extensions="['webp', 'png']"
              img-class="lg:mb-2 object-contain hide-on-med-and-down"
              :img-style="{
                display: 'block',
                maxWidth: '98px',
                width: '100%',
                height: '50px',
                margin: 'auto',
                top: '50%',
                position: 'relative',
              }"
            />
            <svg
              class="object-contain hide-on-large-only mx-auto"
              width="48"
              height="60"
              viewBox="0 0 48 60"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              style="display: block"
            >
              <rect x="22" y="16" width="4" height="30" rx="2" fill="black" />
              <path
                d="M12 32 L24 48 L36 32"
                stroke="black"
                stroke-width="5"
                stroke-linecap="round"
                stroke-linejoin="round"
                fill="none"
              />
            </svg>
          </div>
          <div class="w-full lg:w-1/5">
            <PictureImg
              src="/images/services/web-app/process-handover"
              alt="Handover"
              :extensions="['webp', 'png']"
              img-class="lg:mb-2"
              :img-style="{ display: 'block', height: '14vh', maxHeight: '150px', margin: 'auto' }"
            />
            <h4
              class="text-2xl lg:text-2xl m-0 lg:mb-2 txt--bold teal white-text uppercase mt-4 inline-block px-4 lg:px-2 py-1"
            >
              5. Handover
            </h4>
            <p class="text-lg lg:text-xl text-balance">
              Delivering the final product with full documentation and launch-ready support.
            </p>
          </div>
        </div>
      </section>

      <section id="portfolio" class="relative container-lg my-24 lg:my-48">
        <h2 class="center-align text-3xl lg:text-4xl font-bold teal-text text-darken-3 text-darken-3 mb-12 uppercase">
          Portfolio
        </h2>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 center-align">
          <div class="card h-full rounded-lg flex flex-col items-center justify-start p-0 lg:p-2">
            <PictureImg
              src="/images/services/web-app/mockup-genau"
              alt="Genau Indonesia"
              :extensions="['webp', 'png']"
              img-class="mb-2 object-contain"
              :img-style="{ display: 'block', width: '100%', height: '100%', margin: 'auto' }"
            />
            <div class="w-full">
              <a href="https://genau.id" target="_blank">
                <h3
                  class="btn waves-effect text-2xl lg:text-2xl m-0 lg:mb-2 txt--bold green white-text uppercase inline-block px-9 py-1 rounded-lg"
                >
                  Genau Indonesia
                </h3>
              </a>
              <p class="text-lg lg:text-xl text-balance p-2 lg:p-0">
                Genau Indonesia is an organization committed to preserving Indonesia’s tropical rainforests through
                education, ecotourism, and community empowerment.
              </p>
            </div>
          </div>
          <div class="card h-full rounded-lg flex flex-col items-center justify-start p-0 lg:p-2">
            <PictureImg
              src="/images/services/web-app/mockup-kanopi"
              alt="Kanopi Indonesia"
              :extensions="['webp', 'png']"
              img-class="mb-2 object-contain"
              :img-style="{ display: 'block', width: '100%', height: '100%', margin: 'auto' }"
            />
            <div class="w-full">
              <a href="https://kanopi-indonesia.org" target="_blank">
                <h3
                  class="btn waves-effect text-2xl lg:text-2xl m-0 lg:mb-2 txt--bold green white-text uppercase inline-block px-9 py-1 rounded-lg"
                >
                  Kanopi Indonesia
                </h3>
              </a>
              <p class="text-lg lg:text-xl text-balance p-2 lg:p-0">
                Kanopi Indonesia is an organization focused on environmental conservation, community empowerment,
                research, and education.
              </p>
            </div>
          </div>
        </div>
        <div class="flex flex-col justify-center items-center center-align gap-y-2 pt-12">
          <p class="lg:text-xl txt--bold">More creations from Rasylva.id's software engineer</p>
          <a
            href="https://drive.google.com/file/d/1osU0ZuqZzvTNIWRrKTkLRy_dPk0NSnYs/view?usp=drive_link"
            target="_blank"
            rel="noreferrer"
            class="block btn waves-effect teal btn-large txt--bold"
            >MORE PORTFOLIOS HERE!</a
          >
        </div>
      </section>

      <section
        id="services"
        class="relative container-lg mx-0 w-full lg:mx-auto my-24 lg:my-48 green px-9 lg:px-18 py-20 rounded-3xl"
        :style="{
          backgroundImage: `url('/images/services/web-app/geometric-0.webp') !important`,
          backgroundSize: 'cover !important',
          backgroundPosition: 'left center !important',
          backgroundRepeat: 'no-repeat !important',
        }"
      >
        <h2 class="center-align text-3xl lg:text-5xl font-bold white-text mt-0 mb-6 lg:mb-12 uppercase">
          Have a Project in Mind?
        </h2>
        <div class="flex flex-col justify-center items-center center-align gap-y-4">
          <PictureImg
            src="/images/services/web-app/illus-cta-form"
            alt="Quality Illustration"
            :extensions="['webp', 'png']"
            class="hide-on-med-and-down"
            :img-style="{ display: 'block', width: '75%', height: '100%', margin: 'auto' }"
          />
          <PictureImg
            src="/images/services/web-app/illus-cta-form-mobile"
            alt="Quality Illustration"
            :extensions="['webp', 'png']"
            class="hide-on-large-only"
            :img-style="{ display: 'block', width: '100%', height: '100%', margin: 'auto' }"
          />
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSeGk_9a3ea7MChhNmd0t0Dcjg8s3KsKKTuz8kbVqBHEHwUn1A/viewform?usp=dialog"
            target="_blank"
            rel="noreferrer"
            class="btn waves-effect teal btn-large txt--bold"
          >
            FILL OUT THE FORM HERE!
          </a>
        </div>
      </section>

      <section
        id="testimony"
        class="relative my-24 lg:my-48 teal py-20 white-text"
        :style="{ backgroundImage: `url('/images/services/web-app/geometric-1.webp') !important` }"
      >
        <div class="testimony-slider">
          <h2 class="center-align text-3xl lg:text-4xl font-bold white-text mb-12 uppercase">What Our Clients Say</h2>
          <!-- <button
            class="testimony-slider__arrow testimony-slider__arrow--left hide-on-med-and-down"
            aria-label="Previous testimony"
            tabindex="0"
            @click="handleTestimonyPrev"
            @keydown.enter="handleTestimonyPrev"
          >
            <span>&lt;</span>
          </button>
          <button
            class="testimony-slider__arrow testimony-slider__arrow--right hide-on-med-and-down"
            aria-label="Next testimony"
            tabindex="0"
            @click="handleTestimonyNext"
            @keydown.enter="handleTestimonyNext"
          >
            <span>&gt;</span>
          </button> -->
          <div class="testimony-slider__indicators hide-on-large-only">
            <div
              v-for="id in testimonies.length"
              :key="id"
              class="testimony-slider__indicators__dot"
              :class="{ active: activeTestimony === id }"
            ></div>
          </div>
          <div ref="testimonySlider" class="testimony-slider__container">
            <div v-for="(testimony, idx) in testimonies" :key="idx" class="testimony-slider__item">
              <div class="testimony-card">
                <span class="testimony-card__quote testimony-card__quote--open">“</span>
                <div class="testimony-card__text">
                  <span v-html="testimony.content"></span>
                </div>
                <span class="testimony-card__quote testimony-card__quote--close">”</span>
                <div class="testimony-card__profile">
                  <PictureImg
                    class="testimony-card__photo"
                    :src="testimony.image"
                    alt="Testimony Photo"
                    :extensions="['webp', 'png']"
                    img-class="testimony-card__image"
                  />
                  <div class="testimony-card__name">
                    <b>{{ testimony.name }}</b>
                    <span v-html="testimony.title"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="faq" class="relative container my-24 lg:my-36">
        <h2 class="center-align text-3xl lg:text-5xl font-bold teal-text mb-12 uppercase">
          Frequently Asked Questions
        </h2>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
          <div class="faq-illustration">
            <PictureImg
              :src="'/images/services/web-app/illus-faq'"
              alt="FAQ Illustration"
              :extensions="['webp', 'png']"
              img-class="faq-image"
            />
          </div>
          <div class="faq-accordion">
            <div
              v-for="(faq, index) in faqs"
              :key="index"
              class="faq-item"
              :class="{ 'faq-item--active': activeFaq === index }"
            >
              <button
                class="faq-item__header"
                type="button"
                :aria-expanded="activeFaq === index"
                :aria-controls="`faq-content-${index}`"
                @click="handleFaqToggle(index)"
                @keydown.enter="handleFaqToggle(index)"
              >
                <span class="faq-item__question">{{ faq.question }}</span>
                <svg
                  class="faq-item__icon"
                  :class="{ 'faq-item__icon--rotated': activeFaq === index }"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 9L12 15L18 9"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
              <div
                :id="`faq-content-${index}`"
                class="faq-item__content"
                :class="{ 'faq-item__content--open': activeFaq === index }"
              >
                <p v-html="faq.answer"></p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        id="idea-reality"
        class="relative container-lg mx-0 w-full lg:mx-auto my-24 lg:my-36 lg:mb-24 green px-9 lg:px-18 py-20 lg:py-36 rounded-3xl"
        :style="{
          backgroundImage: `url('/images/services/web-app/geometric-0.webp') !important`,
          backgroundSize: 'cover !important',
          backgroundPosition: 'left center !important',
          backgroundRepeat: 'no-repeat !important',
        }"
      >
        <div class="flex flex-col lg:flex-row gap-4 px-2 lg:px-6 items-center">
          <div class="text-center lg:text-left">
            <h2 class="text-5xl lg:text-8xl font-bold white-text uppercase m-0">Let's Turn Your Idea Into Reality</h2>
            <div class="hide-on-large-only" style="text-align: center; margin-top: 24px">
              <PictureImg
                src="/images/services/web-app/illus-cta-idea"
                alt="Idea to Reality Illustration"
                :extensions="['webp', 'png']"
                :img-style="{
                  display: 'block',
                  height: '28vh',
                  maxHeight: '250px',
                  margin: 'auto',
                }"
              />
            </div>
            <p class="white-text text-2xl lg:text-4xl mv-4 txt--bold text-balance">
              Start your digital journey with us!
            </p>
            <a
              href="https://wa.me/6285187877001?text=Halo%20Admin%20Rasylva.id!%0ASaya%20datang%20dari%20website%20Rasylva.id.%0A%0ANama%3A%0AInstansi%3A%0A%0ASaya%20mau%20bertanya%20tentang%20..."
              target="_blank"
              rel="noopener noreferrer"
              class="btn teal waves-effect btn-large font-medium px-9"
              tabindex="0"
            >
              Let's Talk!
            </a>
          </div>
          <div class="hide-on-med-and-down" style="text-align: right">
            <PictureImg
              src="/images/services/web-app/illus-cta-idea"
              alt="Idea to Reality Illustration"
              :extensions="['webp', 'png']"
              :img-style="{ display: 'inline-block', height: '35vh', maxHeight: '320px' }"
            />
          </div>
        </div>
      </section>

      <section id="seo-text" class="container pt-8">
        <hr />
        <h1 style="font-size: 16px">Rasylva.id Web/App Development Service</h1>
        <p>
          Rasylva.id provides professional web and app development services focused on high-quality, customizable, and
          easy-to-maintain digital solutions to support your business or organizational needs.
        </p>
        <p>
          Our expertise goes beyond building web-based applications; it's supported by a solid background in natural
          sciences and hands-on experience developing various research platforms and environmental applications. We
          understand the importance of precision and efficiency in data management and analysis, especially for sectors
          focused on innovation and sustainability.
        </p>
        <p>
          We offer free consultation to help you plan your application’s requirements—whether you are a small business,
          a scientific organization, or a large company. The Rasylva.id team will guide you through defining needs and
          specifications, designing responsive interfaces, and ensuring your application runs optimally on any device.
        </p>
        <p>
          Every digital solution we develop is designed to be user-friendly, time-saving, and to streamline your
          workflow. This includes digitizing field data collection, automating calculations and classifications, and
          integrating cloud storage for data security and access. With a paperless approach, our solutions also support
          environmentally friendly goals.
        </p>
        <p>
          We also provide after-sales support, maintenance, and application updates, allowing you to focus on innovation
          without worrying about application upkeep. Our team is used to working with clients from various disciplines,
          including scientific communities, businesses, and nonprofits.
        </p>
        <p>
          Entrust your web application needs to Rasylva.id and achieve more efficient, modern, and sustainable data and
          business management. Consult your digital needs with our team of experts for free today!
        </p>
      </section>
    </main>
    <PageFooter />
  </div>
</template>

<script>
import PageFooter from '~/components/page-footer';
import PageHeader from '~/components/page-header';
import PictureImg from '~/components/picture-img';

import datetimeMixin from '~/mixins/datetime';
import moneyMixin from '~/mixins/money';

export default {
  components: {
    PageFooter,
    PageHeader,
    PictureImg,
  },
  mixins: [datetimeMixin, moneyMixin],
  data: () => ({
    activeTestimony: 1,
    activeFaq: 0,
    faqs: [
      {
        question: 'How much will it cost to develop a website or app?',
        answer:
          'We can only provide an estimate after you complete the <a href="https://docs.google.com/forms/d/e/1FAIpQLSeGk_9a3ea7MChhNmd0t0Dcjg8s3KsKKTuz8kbVqBHEHwUn1A/viewform?usp=dialog" target="_blank" rel="noreferrer">Web/App Development Requirement Form</a>. We also offer <a href="https://wa.me/6285187877001?text=Halo%20Admin%20Rasylva.id!%0ASaya%20datang%20dari%20website%20Rasylva.%0A%0ANama%3A%0AInstansi%3A%0A%0ASaya%20mau%20bertanya%20tentang%20..." target="_blank" rel="noreferrer">Free consultation</a> to help you plan your requirements. The final price will be determined by the complexity of the project and the timeline.',
      },
      {
        question: 'Do I need a detailed project plan before contacting Rasylva.id?',
        answer:
          'No. We guide you through defining requirements during the <a href="https://wa.me/6285187877001?text=Halo%20Admin%20Rasylva.id!%0ASaya%20datang%20dari%20website%20Rasylva.%0A%0ANama%3A%0AInstansi%3A%0A%0ASaya%20mau%20bertanya%20tentang%20..." target="_blank" rel="noreferrer">Free consultation</a>.',
      },
      {
        question: 'How long does a typical project take?',
        answer:
          'Project timelines vary depending on complexity. A simple website typically takes 1-2 months, while more complex web applications may take 3-6 months. We will provide a detailed timeline during the consultation.',
      },
      {
        question: 'Do you provide ongoing support?',
        answer:
          'Yes, we offer ongoing support and maintenance packages to ensure your application runs smoothly after launch. This includes bug fixes, updates, and technical assistance.',
      },
      {
        question: 'Do you only work with natural science projects?',
        answer:
          'While we specialize in natural science and environmental projects, we welcome clients from all industries. Our expertise in data visualization and scientific applications can benefit many sectors.',
      },
    ],
    testimonies: [
      {
        image: '/images/services/web-app/testimony-amel',
        name: 'Amelia Nugrahaningrum',
        title: 'Founder Genau Indonesia',
        content: `Our experience with Rasylva.id's service has been both professional and personal. Beyond their excellent performance, they genuinely listened to our needs and worked hard to fulfill them.
                  <br />
                  <br />
                  Thanks to Rasylva.id, our website has improved to better suit our current needs. Moreover, with a more user-friendly and professional design, we’ve gained greater trust from third parties such as partner stakeholders and customers.`,
      },
      {
        image: '/images/services/web-app/testimony-nurina',
        name: 'Nurina Indriyani',
        title: 'Direktur Yayasan Kanopi Indonesia',
        content:
          'Rasylva.id demonstrates a strong understanding of Kanopi’s needs, particularly in translating the brand identity and sustainability values into the website’s visual appearance and structure. The development process was communicative, responsive, and sufficiently flexible in accommodating feedback. The final website is considered neat, functional, and capable of effectively supporting Kanopi’s communication needs and digital program visibility.',
      },
    ],
  }),
  computed: {
    basicPackage() {
      return this.availablePackages.filter((p) => p.product_type.includes('Basic'));
    },
    proPackage() {
      return this.availablePackages.filter((p) => p.product_type.includes('Pro'));
    },
  },
  async mounted() {
    this.initListeners();
    await this.$nextTick();
    setTimeout(async () => {
      await this.$rasylvaApi.init(true);
    }, 10);
    this.setupTestimonyScrollListener();
  },
  beforeDestroy() {
    this.removeTestimonyScrollListener();
  },
  methods: {
    initListeners() {
      const { testimonySlider } = this.$refs;
      testimonySlider.addEventListener('scroll', () => {
        const totalWidth = testimonySlider.scrollWidth - 40;
        this.activeTestimony = Number.parseInt((testimonySlider.scrollLeft / totalWidth) * this.testimonies.length + 1);
      });
    },
    destroyListeners() {
      const { testimonySlider } = this.$refs;
      testimonySlider.removeEventListener('scroll', this.handleScroll);
    },
    setupTestimonyScrollListener() {
      this.$nextTick(() => {
        const { testimonySlider } = this.$refs;
        if (testimonySlider) {
          this.handleTestimonyScroll = this.handleTestimonyScroll.bind(this);
          testimonySlider.addEventListener('scroll', this.handleTestimonyScroll);
        }
      });
    },
    removeTestimonyScrollListener() {
      const { testimonySlider } = this.$refs;
      if (testimonySlider && this.handleTestimonyScroll) {
        testimonySlider.removeEventListener('scroll', this.handleTestimonyScroll);
      }
    },
    handleTestimonyScroll() {
      const { testimonySlider } = this.$refs;
      if (!testimonySlider) return;

      const scrollLeft = testimonySlider.scrollLeft;
      const containerWidth = testimonySlider.clientWidth;
      const isDesktop = window.innerWidth >= 960;
      const gap = 24;

      let activeIndex;
      if (isDesktop) {
        // On desktop, each item is calc(50% - 12px), so itemWidth = (containerWidth / 2) - 12
        // Distance from start of one item to start of next = itemWidth + gap
        const itemWidth = containerWidth / 2 - 12;
        const itemSpacing = itemWidth + gap;
        // Find which item's start position is closest to current scroll position
        activeIndex = Math.round(scrollLeft / itemSpacing) + 1;
      } else {
        // On mobile, each item is 100% width (containerWidth) with gap between items
        const itemSpacing = containerWidth + gap;
        activeIndex = Math.round(scrollLeft / itemSpacing) + 1;
      }

      // Clamp the index to valid range
      activeIndex = Math.max(1, Math.min(activeIndex, this.testimonies.length));
      this.activeTestimony = activeIndex;
    },
    handleTestimonyPrev() {
      const { testimonySlider } = this.$refs;
      if (!testimonySlider) return;

      const isDesktop = window.innerWidth >= 960;
      const gap = 24;
      let scrollDistance;

      if (isDesktop) {
        // On desktop, scroll by 1 item (50% width) + gap
        const itemWidth = testimonySlider.clientWidth / 2 - 12;
        scrollDistance = itemWidth + gap;
      } else {
        // On mobile, scroll by 1 item (100% width) + gap
        scrollDistance = testimonySlider.clientWidth + gap;
      }

      testimonySlider.scrollBy({ left: -scrollDistance, behavior: 'smooth' });
    },
    handleTestimonyNext() {
      const { testimonySlider } = this.$refs;
      if (!testimonySlider) return;

      const isDesktop = window.innerWidth >= 960;
      const gap = 24;
      let scrollDistance;

      if (isDesktop) {
        // On desktop, scroll by 1 item (50% width) + gap
        const itemWidth = testimonySlider.clientWidth / 2 - 12;
        scrollDistance = itemWidth + gap;
      } else {
        // On mobile, scroll by 1 item (100% width) + gap
        scrollDistance = testimonySlider.clientWidth + gap;
      }

      testimonySlider.scrollBy({ left: scrollDistance, behavior: 'smooth' });
    },
    handleFaqToggle(index) {
      this.activeFaq = this.activeFaq === index ? null : index;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~/styles/mixins';
@import '~/styles/variables';

.hero-section {
  position: relative;
  background-color: $rasylva-teal;
  color: white;
  min-height: 90vh;
  background-size: cover !important;
  background-position: top center !important;
  background-repeat: no-repeat !important;
  display: flex;
  align-items: center;
  justify-content: center;
  @include desktop {
    min-height: 100svh;
  }
}

::v-deep .hero-image {
  position: relative;
  object-fit: contain;
  width: 100%;
  padding: 0 24px;
  @include tablet {
    width: 68%;
  }
  @include desktop {
    width: 100%;
    margin: 0;
    max-height: 450px;
  }
}

.hero-text {
  text-align: center;
  @include desktop {
    text-align: left;
    width: 90%;
    margin: auto;
  }
}

.expertise-section {
  background-color: white;
  margin: 64px 0;
  @include desktop {
    margin: 120px 0;
  }
}

.expertise-text {
  text-align: center;
  @include desktop {
    padding-right: 48px;
    text-align: left;
  }
}

.expertise-heading {
  color: $rasylva-teal;
  font-size: 1.75rem;
  font-weight: 700;
  line-height: 1.3;
  margin-top: 36px;
  margin-bottom: 16px;
  text-wrap: balance;
  @include tablet {
    font-size: 1.75rem;
  }
  @include desktop {
    font-size: 2rem;
  }
}

.expertise-description {
  color: #333;
  font-size: 1.25rem;
  line-height: 1.7;
  @include desktop {
    font-size: 1.5rem;
    font-size: 1.75rem;
  }
}

.expertise-image {
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .expertise-illustration {
  width: 100%;
  max-width: 450px;
  height: auto;
  object-fit: contain;
}

[data-tooltip] {
  position: relative;
  border-bottom: 1px dashed #000;
  cursor: help;
}

[data-tooltip]::after {
  position: absolute;
  opacity: 0;
  pointer-events: none;
  content: attr(data-tooltip);
  right: 0;
  top: calc(100% + 10px);
  border-radius: 3px;
  box-shadow: 0 0 5px 2px rgba(100, 100, 100, 0.6);
  background-color: white;
  color: black;
  z-index: 10;
  padding: 8px;
  width: 300px;
  transform: translateY(-20px);
  transition: all 150ms cubic-bezier(0.25, 0.8, 0.25, 1);
}

[data-tooltip]:hover::after {
  opacity: 1;
  transform: translateY(0);
  transition-duration: 300ms;
}

.testimony-slider {
  position: relative;
  &__arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: white;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transition: all 0.2s ease;
    &:hover {
      transform: translateY(-50%) scale(1.1);
    }
    span {
      font-size: 3rem;
      font-weight: bold;
      color: $rasylva-teal;
      line-height: 1;
      padding-bottom: 4px;
    }
    &--left {
      left: 2%;
      @media only screen and (min-width: 960px) {
        left: 5%;
      }
    }
    &--right {
      right: 2%;
      @media only screen and (min-width: 960px) {
        right: 5%;
      }
    }
  }
  &__container {
    display: flex;
    margin: auto;
    overflow-x: scroll;
    overflow-y: visible;
    scroll-behavior: smooth;
    scroll-snap-type: x mandatory;
    width: 90%;
    gap: 24px;
    @media only screen and (min-width: 960px) {
      overflow-x: auto;
      width: 70%;
    }
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }
  }
  &__item {
    width: 100%;
    flex-shrink: 0;
    overflow: visible;
    margin-top: 20px;
    margin-bottom: 144px;
    @media only screen and (max-width: 960px) {
      &:nth-of-type(1n + 1) {
        scroll-snap-align: start;
        scroll-snap-stop: always;
      }
    }
    @media only screen and (min-width: 960px) {
      width: calc(50% - 12px);
      flex-shrink: 0;
      &:nth-of-type(2n + 1) {
        scroll-snap-align: start;
        scroll-snap-stop: always;
      }
    }
  }
  &__indicators {
    background: none;
    border-radius: 20px;
    bottom: -40px;
    display: flex;
    left: 50%;
    padding: 0;
    position: absolute;
    transform: translateX(-50%);
    z-index: 9;
    &__dot {
      background: rgba(255, 255, 255, 0.5);
      border-radius: 50%;
      border: 0;
      height: 10px;
      margin: 6px;
      width: 10px;
      &.active {
        background: white;
      }
    }
  }
}

.testimony-card {
  background: $rasylva-green;
  border-radius: 24px;
  padding: 32px 24px 44px;
  position: relative;
  min-height: 400px;
  height: 100%;
  display: flex;
  align-items: center;
  overflow: visible;
  &__quote {
    font-family: serif;
    font-size: 8rem;
    font-weight: bold;
    color: white;
    line-height: 1;
    position: absolute;
    &--open {
      top: -32px;
      left: -12px;
    }
    &--close {
      bottom: -72px;
      right: 0px;
    }
  }
  &__text {
    color: white;
    font-size: 1.125rem;
    line-height: 1.6;
    font-weight: 500;
    text-align: center;
    flex: 1;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 16px 8px;
  }
  &__profile {
    position: absolute;
    bottom: 0;
    transform: translateY(50%);
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-top: auto;
    padding-top: 72px;
  }
}

::v-deep .testimony-card {
  &__image {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    object-fit: cover;
    margin-bottom: 12px;
    @include desktop {
      width: 120px;
      height: 120px;
    }
  }
  &__name {
    color: white;
    b {
      font-size: 1.25rem;
      display: block;
      margin-bottom: 4px;
      @include desktop {
        font-size: 1.25rem;
      }
    }
    span {
      font-size: 1.125rem;
      opacity: 0.9;
      @include desktop {
        font-size: 1.125rem;
      }
    }
  }
}

.faq-illustration {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

::v-deep .faq-image {
  width: 100%;
  max-width: 500px;
  height: auto;
  object-fit: contain;
}

.faq-accordion {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.faq-item {
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.2s ease;

  &__header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    background: white;
    border: none;
    cursor: pointer;
    text-align: left;
    gap: 16px;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #f9f9f9;
    }
  }

  &__question {
    font-size: 1rem;
    font-weight: 700;
    color: #333;
    flex: 1;
  }

  &__icon {
    color: #666;
    flex-shrink: 0;
    transition: transform 0.3s ease;

    &--rotated {
      transform: rotate(180deg);
    }
  }

  &__content {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease, padding 0.3s ease;
    background: white;

    p {
      padding: 0 20px 16px;
      margin: 0;
      color: #666;
      font-size: 0.95rem;
      line-height: 1.6;
    }

    &--open {
      max-height: 200px;
    }
  }
}
</style>
